import React from 'react'
import styled from 'styled-components'
import { backgroundColors } from 'config'

const Wrapper = styled.div`
  text-align: center;
  width: 150px;
  cursor: pointer;

  @media screen and (max-width: 768px) {
    width: 100px;
  }
`

const CenteredBox = styled.div`
  border: 1px solid #dedede;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  height: 80px;
  width: 80px;
  margin: 0 auto;
  border-radius: 0px;

  &:hover,
  &.selected {
    background: ${({ bgColor }) => bgColor};

    svg path {
      fill: #fff;
    }
  }

  @media screen and (max-width: 768px) {
    width: 65px;
    height: 65px;
  }
`

const Title = styled.span`
  display: block;
  text-transform: uppercase;
  margin-top: 20px;
  font-size: 12px;
  line-height: 12px;
  color: #010101;
  font-weight: bold;
  text-align: center;
  font-family: 'Nunito', 'Helvetica Neue', sans-serif;

  @media screen and (max-width: 768px) {
    font-size: 10px;
  }
`

const Button = ({ icon, name, selected, onClick, className }) => (
  <Wrapper onClick={onClick} className={className}>
    <CenteredBox
      bgColor={backgroundColors.normalRight}
      className={selected && 'selected'}>
      {icon}
    </CenteredBox>
    <Title>{name}</Title>
  </Wrapper>
)

export default Button



// WEBPACK FOOTER //
// ./src/components/ButtonRadio/index.js